import { createContext, useContext } from 'react';

export const ArquivoContext = createContext<{
  reloadFiles: () => Promise<void>;
}>(undefined as any);

export const useArquivoContext = () => {
  const result = useContext(ArquivoContext);
  if (!result) {
    throw new Error(
      'useArquivoContext precisa ser usado dentro de um ArquivoContext.Provider'
    );
  }
  return result;
};
